var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 28,
    viewBox: "0 0 80 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4262 12.7879V0.666668H10.8852L6.29504 12.7879H14.4262Z",
    fill: "#FF000F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.8361,
    y: 0.666668,
    width: 9.04917,
    height: 12.1212,
    fill: "#FF000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1968 12.7879H77.1148C76.1968 11.8182 75.0165 11.0909 73.705 10.6061C75.0165 9.51515 75.8033 8.06061 75.8033 6.36364C75.8033 3.21212 71.7378 0.666668 68.3279 0.666668H68.1968V12.7879Z",
    fill: "#FF000F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7377 12.7879H24L19.2787 0.666668H15.7377V12.7879Z",
    fill: "#FF000F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0328 14H68.1968V27.3333C68.4591 27.3333 70.0328 27.3333 70.164 27.3333C75.4099 27.3333 79.6066 23.4545 79.6066 18.6061C79.6066 17.0303 79.2132 15.697 78.4263 14.4848L78.0328 14Z",
    fill: "#FF000F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8852 14H57.8361V27.3333H66.8852C66.0983 27.3333 66.8852 27.3333 66.8852 27.3333V14Z",
    fill: "#FF000F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7869,
    y: 0.666668,
    width: 9.04918,
    height: 12.1212,
    fill: "#FF000F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2787 12.7879H52.1967C51.2787 11.8182 50.0983 11.0909 48.7869 10.6061C50.0983 9.51515 50.8852 8.06061 50.8852 6.36364C50.8852 3.21212 46.8197 0.666668 43.4098 0.666668H43.2787V12.7879Z",
    fill: "#FF000F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1147 14H43.2787V27.3333C43.541 27.3333 45.1148 27.3333 45.2459 27.3333C50.4918 27.3333 54.6885 23.4545 54.6885 18.6061C54.6885 17.0303 54.2951 15.697 53.5082 14.4848L53.1147 14Z",
    fill: "#FF000F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8361 14H32.7869V27.3333H41.8361C41.0492 27.3333 41.8361 27.3333 41.8361 27.3333V14Z",
    fill: "#FF000F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4262 14H5.77051L5.63937 14.4848L0.655762 27.3333H8.00002L9.96723 22H14.4262V14Z",
    fill: "#FF000F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3934 14H15.7377V22H20.1967L22.295 27.3333H29.5082L24.6557 14.4848L24.3934 14Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/abb_logo.25bb167d9a7f7329c60b986750d2b695.svg";
export { ForwardRef as ReactComponent };